import { useEffect, useRef } from 'react';
import { AppState } from 'react-native';
import Constants from 'src/core/utils/Constants';
import AppStateHelper from 'src/presentation/helpers/AppStateHelper';

type Props = {
	onInit?: () => void;
	onForegrounded?: () => void;
	onBackgrounded?: () => void;
};

function useAppStateGlobalListener(props: Props) {
	const appState = useRef(AppState.currentState);
	const callbacks = useRef(props);

	useEffect(() => {
		callbacks.current = props;
	});

	useEffect(() => {
		const appStateChangedListener = AppState.addEventListener(Constants.appStateEventChange, (nextAppState) => {
			if (
				AppStateHelper.isForegrounded({
					current: appState.current,
					next: nextAppState,
				})
			) {
				callbacks.current.onForegrounded?.();
			} else {
				callbacks.current.onBackgrounded?.();
			}

			appState.current = nextAppState;
		});

		callbacks.current.onInit?.();

		return () => {
			appStateChangedListener.remove();
		};
	}, []);

	return null;
}

export default useAppStateGlobalListener;
